import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function ResultFinal() {
  return (
    <section className=" centerimg_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="text-center m-auto"
          >
            <h2>
              What were the<span style={{ color: "#6D4FC1" }}> Results?</span>
            </h2>
            <p>
              The results were just what we planned and worked for. The
              application saw the completion of its development and was launched
              smoothly to go into the hands of the consumers.
            </p>
          </Col>
          <Col
            xs={12}
            md={10}
            lg={8}
            xl={8}
            xxl={8}
            className="text-center m-auto"
          >
            <div className="img_come">
              <StaticImage
                src="../../../images/case-studies/nurse-practition/tek_img_06.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1063}
                height={653}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ResultFinal;
